<template>
  <div class="resource-cover" :class="{ 'resource-cover--natural': natural }" :style="{ height: natural ? 'auto' : height + 'px', backgroundColor: background }">
    <img :src="source" :alt="name + (source === fallback ? '，暂无保存封面' : '，保存时的样式封面')" :loading="natural ? 'eager' : 'lazy'" :draggable="natural ? false : undefined" decoding="async" crossorigin="anonymous" @error="onImageError" />
    <span v-if="source === fallback">{{ failed ? '样式图片暂不可用' : '暂无保存封面' }}</span>
  </div>
</template>
<script>
import { coverFileUrl } from '@/utils/resource-cover'
import { builtinComponentCover } from '@/utils/builtin-resource-url'
export default {
  props: { fileId: String, resourceId: String, name: { type: String, default: '' }, height: { type: Number, default: 150 }, background: { type: String, default: '#f5f6f8' }, natural: Boolean },
  data: () => ({ failed: false }),
  computed: {
    fallback () { return process.env.BASE_URL + 'ui/resource-cover-empty.svg' },
    remote () { return coverFileUrl(this.fileId) || builtinComponentCover(this.resourceId) },
    source () { return this.failed ? this.fallback : this.remote || this.fallback }
  },
  watch: { fileId () { this.failed = false }, resourceId () { this.failed = false } },
  methods: {
    onImageError () { this.failed = true }
  }
}
</script>
<style scoped>
.resource-cover { position: relative; width: 100%; background: #f5f6f8; overflow: hidden; }
.resource-cover img { width: 100%; height: 100%; object-fit: contain; display: block; }
.resource-cover--natural { width: auto; max-width: calc(100vw - 48px); overflow: visible; }
.resource-cover--natural img { width: auto; height: auto; max-width: calc(100vw - 48px); max-height: var(--resource-preview-image-height, calc(100vh - 128px)); }
.resource-cover span { position: absolute; bottom: 8px; left: 8px; right: 8px; color: #667085; font-size: 12px; text-align: center; }
</style>
